import type { ComponentProps } from 'react'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import IconButton from 'LuxKit/Button/IconButton'
import TextButton from 'LuxKit/Button/TextButton'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import TextLink from 'LuxKit/TextLink'

interface Props extends Pick<ComponentProps<typeof TextButton>, 'to' | 'href' | 'target' | 'onClick' | 'size' | 'verticalOutdent'> {
  children: string
  className?: string
  desktopAsTextLink?: boolean
}

function CarouselViewAllLink({ children, className, desktopAsTextLink, size = 'medium', verticalOutdent, ...linkProps }: Props) {
  const textLink = desktopAsTextLink
    ? <TextLink wrap="no-wrap" className={className} {...linkProps}>{children}</TextLink>
    : <TextButton kind="tertiary" size={size} verticalOutdent={verticalOutdent} className={className} {...linkProps}>{children}</TextButton>

  return <>
    <CSSBreakpoint max="mobile" as="span" className={className}>
      <IconButton kind="tertiary" size={size} verticalOutdent={verticalOutdent} aria-label={children} {...linkProps}>
        <LineArrowRightIcon />
      </IconButton>
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet" as="span" className={className}>
      {textLink}
    </CSSBreakpoint>
  </>
}

export default CarouselViewAllLink
